'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Home, Compass, Upload, Bell, User, FileText } from 'lucide-react';
import CategoryIcon from '@/components/ui/CategoryIcon';

const navItems = [
  { key: 'nav-home',          label: 'Home',      icon: Home,     href: '/' },
  { key: 'nav-discover',      label: 'Discover',  icon: Compass,  href: '/discover' },
  { key: 'nav-upload',        label: 'Upload',    icon: Upload,   href: '/upload-screen' },
  { key: 'nav-scenepacks',    label: 'Packs',     icon: null,     href: '/scenepacks',     categoryKey: 'scenepacks' },
  { key: 'nav-requests',      label: 'Requests',  icon: FileText, href: '/requests' },
  { key: 'nav-notifications', label: 'Alerts',    icon: Bell,     href: '/notifications' },
  { key: 'nav-profile',       label: 'Profile',   icon: User,     href: '/profile' },
];

export default function BottomNav() {
  const pathname = usePathname();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 bottom-nav-blur"
      style={{ background: 'rgba(10, 10, 15, 0.92)', borderTop: '1px solid var(--border)' }}
    >
      <div className="flex items-center justify-around px-1 py-2 max-w-screen-sm mx-auto">
        {navItems?.map((item) => {
          const isActive =
            item?.href === '/'
              ? pathname === '/'
              : pathname?.startsWith(item?.href);

          return (
            <Link
              key={item?.key}
              href={item?.href}
              className="flex flex-col items-center gap-1 px-1.5 py-1.5 rounded-xl transition-all duration-150 group"
              style={{
                color: isActive ? 'var(--primary)' : 'var(--muted-foreground)',
              }}
            >
              {item?.label === 'Upload' ? (
                <span
                  className="flex items-center justify-center w-10 h-10 rounded-xl transition-all duration-150 group-hover:scale-105"
                  style={{
                    background: isActive
                      ? 'linear-gradient(135deg, var(--primary) 0%, #5B54E8 100%)'
                      : 'var(--muted)',
                    boxShadow: isActive ? '0 4px 16px rgba(108, 99, 255, 0.4)' : 'none',
                  }}
                >
                  <Upload
                    size={18}
                    style={{ color: isActive ? 'white' : 'var(--muted-foreground)' }}
                  />
                </span>
              ) : (
                <span
                  className="flex items-center justify-center w-8 h-8 rounded-lg transition-all duration-150 group-hover:scale-105"
                  style={{
                    background: isActive ? 'rgba(108, 99, 255, 0.15)' : 'transparent',
                  }}
                >
                  {item?.categoryKey ? (
                    <CategoryIcon
                      category={item?.categoryKey}
                      size={18}
                      color={isActive ? 'var(--primary)' : 'var(--muted-foreground)'}
                    />
                  ) : item?.icon ? (
                    <item.icon size={18} />
                  ) : null}
                </span>
              )}
              <span
                className="text-[10px] font-semibold transition-all duration-150"
                style={{
                  color: isActive ? 'var(--primary)' : 'var(--muted-foreground)',
                }}
              >
                {item?.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}